import { EventService } from "@core/services/event.service";
import { ApiEventService } from "@core/services/event/api.event.service";

export const environment = {

	name: "devops",
	production: true,
	providers: [
		{
			provide: EventService,
			useClass: ApiEventService,
			multi: false
		}
	],
	msalRedirectUri: 'https://pris.vitens-apps.nl',  // Local development URL
  	msalPostLogoutRedirectUri: 'https://pris.vitens-apps.nl/login',
  	clientId: '3862a48e-f645-4681-9a4d-c0d590e58e74',
  	authority: 'https://login.microsoftonline.com/fd1bf821-4add-4ff1-b820-077590fc58d1',
	localStorage: 'localStorage',
	scopes: ['User.Read'],
	graphUri: 'https://graph.microsoft.com/v1.0/me'
};